import {useCallback} from 'react'
import type {Workday, Workdays} from '@package/shared'
import {WorkdayFormRows} from './WorkdayFormRows.tsx'
import {Table} from '@mantine/core'
import {getLocalWeekdays} from '../../../calendar/formatter/getLocalWeekdays.ts'
import {useUserSettings} from '../../../../providers/userSettings/useUserSettings.ts'

type Props = {
  value: Workdays
  onValueChange: (workdays: Workdays) => void
  disabled: boolean
}

export const WorkweekForm = ({value: workdays, onValueChange, disabled: containerDisabled}: Props) => {
  const {userSettings} = useUserSettings()
  const handleWorkdayChange = useCallback(
    (weekdayIndex: keyof Workdays, workday: Workday | undefined) => {
      onValueChange({
        ...workdays,
        [weekdayIndex]: workday,
      })
    },
    [onValueChange, workdays],
  )

  const disabled = containerDisabled
  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 5}}>
      <Table highlightOnHover={false} verticalSpacing={10} horizontalSpacing={0}>
        <Table.Tbody>
          {getLocalWeekdays(userSettings).map(({weekday, weekdayIndex}) => {
            return (
              <WorkdayFormRows
                key={weekday}
                weekday={weekday}
                defaultValue={workdays[weekdayIndex] || []}
                onValueChange={(workday) => handleWorkdayChange(weekdayIndex, workday)}
                disabled={disabled}
              />
            )
          })}
        </Table.Tbody>
      </Table>
    </div>
  )
}
